import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import s from './siteGateHeader.scss';
import { HeaderWrapper } from '../HeaderWrapper';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { useIsMailboxReferralBM } from '../../../hooks/useIsMailboxReferral';
import { isDefaultSiteName } from '../../../utils/siteName';
export const SiteGateHeader = _ref => {
  let {
    onBackClick,
    genericTitleForDefaultSiteName = false,
    ...props
  } = _ref;
  const {
    t,
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  // TODO: add default site name or fallback
  const {
    siteName
  } = getPremiumEssentialsSafe() ?? {
    siteName: 'your site'
  };
  const isMailboxReferral = useIsMailboxReferralBM();
  const showGenericTitle = genericTitleForDefaultSiteName && isDefaultSiteName(siteName);
  const title = isMailboxReferral ? t('domain_search_gate.business_email_gate.title') : showGenericTitle ? t('domains_search_gate.gate_revamp.generic_site.title') : t('domain_search_gate.domain_gate.page.title', {
    domainName: siteName
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    align: "center",
    width: "100%",
    gap: "SP8"
  }, props), /*#__PURE__*/React.createElement(HeaderWrapper, {
    onBackClick: onBackClick
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: s.siteGateHeaderTitle
  }, title)), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    align: "center"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.domain_gate.connect.subtitle",
    components: [/*#__PURE__*/React.createElement("b", null)]
  })));
};
//# sourceMappingURL=SiteGateHeader.js.map